import type { ValueNodeImplementationDefinition } from '@spotar/runtime';
import { sceneHelper } from '../helper/scene-helper';
import {
  findFirstHitboxInTree,
  toHitboxObjectRef,
} from '../helper/hitbox-helper';
import { readObjectRefId } from '../helper/object-ref';

/**
 * A null result makes every onHitboxClick on it dead, so each dead end is logged:
 * hitboxes authored as children of a CMS model are not part of the published GLB.
 */
function resolveHitboxObjectRef(target: unknown) {
  const objectId = readObjectRefId(target);
  if (!objectId) return null;

  const host = sceneHelper?.getObjectByUUID(objectId);
  if (!host) {
    console.warn(`[hitbox] object ${objectId} is not part of the loaded scene`);
    return null;
  }

  const hitbox = findFirstHitboxInTree(host);
  if (!hitbox) {
    console.warn(`[hitbox] "${host.name || objectId}" contains no SpotAR hitbox`);
    return null;
  }

  return toHitboxObjectRef(hitbox);
}

/**
 * Scene objects load after RuntimeEngine.init, so this must not constant-fold.
 */
export const getHitboxValueImplementation: ValueNodeImplementationDefinition = {
  isVolatile: true,
  implementation: (inputs) => ({
    value: resolveHitboxObjectRef(inputs.target),
  }),
};
